import List from './list/ReferralRequestContactListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})